import {FaCheckCircle} from "react-icons/fa";
import {Link, useLocation} from "react-router-dom";
import {useSession} from "../../../redux/Reducers/AuthReducer";
import {useEffect} from "react";

export default function PaymentSuccess({className, ...props}) {
    // getting params
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const paymentIntent = queryParams.get('payment_intent');
    const paymentIntentClientSecret = queryParams.get('payment_intent_client_secret');
    const redirectStatus = queryParams.get('redirect_status');
    const {authActions} = useSession();

    useEffect(() => {
        if (redirectStatus === 'succeeded')
            authActions.refreshPackage()
    }, [redirectStatus]);

    console.log(paymentIntent)
    console.log(paymentIntentClientSecret)
    console.log(redirectStatus)
    return (
        <div className={` ${className} w-[90%] mx-auto h-full justify-center items-center flex flex-col gap-4`}>
            <FaCheckCircle className={"text-[6rem] lg:text-[8rem] text-green-600"} />
            <p className={"text-base  text-center lg:text-xl font-semibold text-green-600"}>
                Your payment was successful! Thank you for your purchase.
                <Link to={"/practice"}
                    className={"text-secondary-900 cursor-pointer"}
                >
                    {" "}Practice questions
                </Link>
            </p>

        </div>

    )
}